// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./variables.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./advanced.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27m6 8 4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Import CSS Variables */

/* Import Advanced CSS Features */

/* ==========================================================================
   CSS Reset and Normalize
   ========================================================================== */

/* Modern CSS Reset */
*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

/* Remove default margins and paddings */
* {
  margin: 0;
  padding: 0;
}

/* HTML and Body */
html {
  font-size: 16px;
  scroll-behavior: smooth;
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
  -moz-text-size-adjust: 100%;
  text-size-adjust: 100%;
  line-height: 1.15;
  -webkit-tap-highlight-color: transparent;
}

body {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-normal);
  line-height: var(--line-height-normal);
  color: var(--color-text);
  background-color: var(--color-background);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: "kern" 1;
  font-kerning: normal;
  min-height: 100vh;
  overflow-x: hidden;
}

/* Screen Reader Only Content */
.sr-only {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.sr-only:focus {
  position: static !important;
  width: auto !important;
  height: auto !important;
  padding: inherit !important;
  margin: inherit !important;
  overflow: visible !important;
  clip: auto !important;
  white-space: inherit !important;
}

/* Remove list styles on ul, ol elements with a list role */
ul[role='list'],
ol[role='list'] {
  list-style: none;
}

/* Set core root defaults */
html:focus-within {
  scroll-behavior: smooth;
}

/* Set core body defaults */
body {
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

/* A elements that don't have a class get default styles */
a:not([class]) {
  text-decoration-skip-ink: auto;
}

/* Make images easier to work with */
img,
picture,
svg {
  max-width: 100%;
  height: auto;
  display: block;
}

/* Remove built-in form typography styles */
input,
button,
textarea,
select {
  font: inherit;
}

/* Remove animations for people who've turned them off */
@media (prefers-reduced-motion: reduce) {
  html:focus-within {
   scroll-behavior: auto;
  }
  
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* ==========================================================================
   Typography System
   ========================================================================== */

/* Headings */
h1, h2, h3, h4, h5, h6 {
  font-family: var(--font-family-heading);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-tight);
  color: var(--color-text);
  margin-bottom: var(--spacing-4);
  text-wrap: balance;
}

h1 {
  font-size: var(--font-size-5xl);
  font-weight: var(--font-weight-extrabold);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}

h2 {
  font-size: var(--font-size-4xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-tight);
  letter-spacing: var(--letter-spacing-tight);
}

h3 {
  font-size: var(--font-size-3xl);
  font-weight: var(--font-weight-bold);
  line-height: var(--line-height-snug);
}

h4 {
  font-size: var(--font-size-2xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-snug);
}

h5 {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  line-height: var(--line-height-normal);
}

h6 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-normal);
}

/* Paragraphs and Text */
p {
  margin-bottom: var(--spacing-4);
  color: var(--color-text-secondary);
  line-height: var(--line-height-relaxed);
  text-wrap: pretty;
  orphans: 2;
  widows: 2;
}

p:last-child {
  margin-bottom: 0;
}

/* Strong and emphasis */
strong,
b {
  font-weight: var(--font-weight-bold);
  color: var(--color-text);
}

em,
i {
  font-style: italic;
}

/* Small text */
small {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

/* Code and preformatted text */
code,
kbd,
samp,
pre {
  font-family: var(--font-family-mono);
  font-size: 0.9em;
}

code {
  background-color: var(--color-surface);
  padding: var(--spacing-1) var(--spacing-2);
  border-radius: var(--radius-sm);
  color: var(--color-text);
  border: 1px solid var(--color-border);
}

pre {
  background-color: var(--color-surface);
  padding: var(--spacing-4);
  border-radius: var(--radius-md);
  overflow-x: auto;
  border: 1px solid var(--color-border);
  line-height: var(--line-height-relaxed);
}

pre code {
  background: none;
  padding: 0;
  border: none;
  border-radius: 0;
}

/* Blockquotes */
blockquote {
  margin: var(--spacing-6) 0;
  padding: var(--spacing-4) var(--spacing-6);
  border-left: 4px solid var(--color-primary);
  background-color: var(--color-surface);
  border-radius: var(--radius-md);
  font-style: italic;
  color: var(--color-text-secondary);
}

blockquote p {
  margin-bottom: var(--spacing-2);
}

blockquote p:last-child {
  margin-bottom: 0;
}

blockquote cite {
  display: block;
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  font-style: normal;
}

blockquote cite::before {
  content: "— ";
}

/* ==========================================================================
   Links and Navigation
   ========================================================================== */

a {
  color: var(--color-primary);
  text-decoration: none;
  transition: color var(--transition-fast);
  cursor: pointer;
}

a:hover {
  color: var(--color-primary-light);
  text-decoration: underline;
}

a:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

a:focus:not(:focus-visible) {
  outline: none;
}

a:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

/* External links */
a[href^="http"]:not([href*="s-cubus.com"]):not(.btn)::after {
  content: " ↗";
  font-size: 0.8em;
  opacity: 0.7;
}

a.btn:hover {
  text-decoration: none;
}

/* ==========================================================================
   Lists
   ========================================================================== */

ul, ol {
  margin-bottom: var(--spacing-4);
  padding-left: var(--spacing-6);
}

ul {
  list-style-type: disc;
}

ol {
  list-style-type: decimal;
}

li {
  margin-bottom: var(--spacing-2);
  color: var(--color-text-secondary);
  line-height: var(--line-height-relaxed);
}

li:last-child {
  margin-bottom: 0;
}

/* Nested lists */
li ul,
li ol {
  margin-top: var(--spacing-2);
  margin-bottom: var(--spacing-2);
}

/* Description lists */
dl {
  margin-bottom: var(--spacing-4);
}

dt {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  margin-bottom: var(--spacing-1);
}

dd {
  margin-bottom: var(--spacing-3);
  margin-left: var(--spacing-4);
  color: var(--color-text-secondary);
}

/* ==========================================================================
   Tables
   ========================================================================== */

table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--spacing-6);
  background-color: var(--color-surface);
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

thead {
  background-color: var(--color-surface-elevated);
}

th,
td {
  padding: var(--spacing-3) var(--spacing-4);
  text-align: left;
  border-bottom: 1px solid var(--color-border);
}

th {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  font-size: var(--font-size-sm);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wide);
}

td {
  color: var(--color-text-secondary);
}

tbody tr:hover {
  background-color: var(--color-surface);
}

tbody tr:last-child td {
  border-bottom: none;
}

/* ==========================================================================
   Forms and Inputs
   ========================================================================== */

/* Form elements inherit font properties */
input,
textarea,
select,
button {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  color: inherit;
}

/* Form controls */
input,
textarea,
select {
  width: 100%;
  padding: var(--spacing-3) var(--spacing-4);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  background-color: var(--color-surface);
  color: var(--color-text);
  transition: all var(--transition-fast);
  appearance: none;
}

input:focus,
textarea:focus,
select:focus {
  outline: none;
  border-color: var(--color-primary);
  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);
}

input::placeholder,
textarea::placeholder {
  color: var(--color-text-muted);
  opacity: 1;
}

/* Specific input types */
input[type="search"] {
  -webkit-appearance: textfield;
}

input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Textarea */
textarea {
  resize: vertical;
  min-height: 100px;
}

/* Select */
select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right var(--spacing-3) center;
  background-repeat: no-repeat;
  background-size: 16px 12px;
  padding-right: var(--spacing-10);
}

/* Checkboxes and radio buttons */
input[type="checkbox"],
input[type="radio"] {
  width: auto;
  margin-right: var(--spacing-2);
  accent-color: var(--color-primary);
}

/* Labels */
label {
  display: block;
  margin-bottom: var(--spacing-2);
  font-weight: var(--font-weight-medium);
  color: var(--color-text);
  cursor: pointer;
}

/* Fieldsets */
fieldset {
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
  padding: var(--spacing-4);
  margin-bottom: var(--spacing-4);
}

legend {
  font-weight: var(--font-weight-semibold);
  color: var(--color-text);
  padding: 0 var(--spacing-2);
}

/* ==========================================================================
   Buttons
   ========================================================================== */

button {
  cursor: pointer;
  border: none;
  border-radius: var(--radius-md);
  padding: var(--spacing-3) var(--spacing-6);
  font-weight: var(--font-weight-medium);
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-2);
  transition: all var(--transition-fast);
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

button:focus {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

button:focus:not(:focus-visible) {
  outline: none;
}

button:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Button Variants */
.btn-primary {
  background-color: var(--color-primary);
  color: white;
  border: 2px solid var(--color-primary);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--color-primary-light);
  border-color: var(--color-primary-light);
  color: #f59e0b;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-primary:active {
  transform: translateY(0);
  box-shadow: var(--shadow-sm);
}

.btn-secondary {
  background-color: var(--color-secondary);
  color: white;
  border: 2px solid var(--color-secondary);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--color-secondary-light);
  border-color: var(--color-secondary-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-outline {
  background-color: transparent;
  color: var(--color-primary);
  border: 2px solid var(--color-primary);
}

.btn-outline:hover:not(:disabled) {
  background-color: var(--color-primary);
  color: white;
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-ghost {
  background-color: transparent;
  color: var(--color-text);
  border: 2px solid transparent;
}

.btn-ghost:hover:not(:disabled) {
  background-color: var(--color-surface);
  border-color: var(--color-border);
}

.btn-success {
  background-color: var(--color-success);
  color: white;
  border: 2px solid var(--color-success);
}

.btn-success:hover:not(:disabled) {
  background-color: var(--color-success-light);
  border-color: var(--color-success-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-warning {
  background-color: var(--color-warning);
  color: white;
  border: 2px solid var(--color-warning);
}

.btn-warning:hover:not(:disabled) {
  background-color: var(--color-warning-light);
  border-color: var(--color-warning-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.btn-error {
  background-color: var(--color-error);
  color: white;
  border: 2px solid var(--color-error);
}

.btn-error:hover:not(:disabled) {
  background-color: var(--color-error-light);
  border-color: var(--color-error-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* ==========================================================================
   Media Elements
   ========================================================================== */

/* Images */
img {
  max-width: 100%;
  height: auto;
  display: block;
  border-radius: var(--radius-md);
}

/* Figures */
figure {
  margin: var(--spacing-6) 0;
}

figcaption {
  margin-top: var(--spacing-2);
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
  text-align: center;
  font-style: italic;
}

/* Audio and Video */
audio,
video {
  width: 100%;
  height: auto;
  border-radius: var(--radius-md);
}

/* ==========================================================================
   Utility Classes - Layout
   ========================================================================== */

.container {
  width: 100%;
  max-width: var(--container-xl);
  margin: 0 auto;
  padding: 0 var(--spacing-4);
}

.container-sm { max-width: var(--container-sm); }
.container-md { max-width: var(--container-md); }
.container-lg { max-width: var(--container-lg); }
.container-2xl { max-width: var(--container-2xl); }

/* Flexbox Utilities */
.flex { display: flex; }
.inline-flex { display: inline-flex; }
.flex-col { flex-direction: column; }
.flex-row { flex-direction: row; }
.flex-wrap { flex-wrap: wrap; }
.flex-nowrap { flex-wrap: nowrap; }

.items-start { align-items: flex-start; }
.items-center { align-items: center; }
.items-end { align-items: flex-end; }
.items-stretch { align-items: stretch; }
.items-baseline { align-items: baseline; }

.justify-start { justify-content: flex-start; }
.justify-center { justify-content: center; }
.justify-end { justify-content: flex-end; }
.justify-between { justify-content: space-between; }
.justify-around { justify-content: space-around; }
.justify-evenly { justify-content: space-evenly; }

.flex-1 { flex: 1 1 0%; }
.flex-auto { flex: 1 1 auto; }
.flex-initial { flex: 0 1 auto; }
.flex-none { flex: none; }

/* Grid Utilities */
.grid { display: grid; }
.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }
.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }
.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }

.gap-1 { gap: var(--spacing-1); }
.gap-2 { gap: var(--spacing-2); }
.gap-3 { gap: var(--spacing-3); }
.gap-4 { gap: var(--spacing-4); }
.gap-6 { gap: var(--spacing-6); }
.gap-8 { gap: var(--spacing-8); }

/* Spacing Utilities */
.m-0 { margin: 0; }
.m-auto { margin: auto; }
.mx-auto { margin-left: auto; margin-right: auto; }
.my-auto { margin-top: auto; margin-bottom: auto; }

.p-0 { padding: 0; }
.p-4 { padding: var(--spacing-4); }
.p-6 { padding: var(--spacing-6); }
.p-8 { padding: var(--spacing-8); }

.px-4 { padding-left: var(--spacing-4); padding-right: var(--spacing-4); }
.py-4 { padding-top: var(--spacing-4); padding-bottom: var(--spacing-4); }

/* Text Utilities */
.text-left { text-align: left; }
.text-center { text-align: center; }
.text-right { text-align: right; }
.text-justify { text-align: justify; }

.text-xs { font-size: var(--font-size-xs); }
.text-sm { font-size: var(--font-size-sm); }
.text-base { font-size: var(--font-size-base); }
.text-lg { font-size: var(--font-size-lg); }
.text-xl { font-size: var(--font-size-xl); }
.text-2xl { font-size: var(--font-size-2xl); }
.text-3xl { font-size: var(--font-size-3xl); }

.font-light { font-weight: var(--font-weight-light); }
.font-normal { font-weight: var(--font-weight-normal); }
.font-medium { font-weight: var(--font-weight-medium); }
.font-semibold { font-weight: var(--font-weight-semibold); }
.font-bold { font-weight: var(--font-weight-bold); }

.text-primary { color: var(--color-primary); }
.text-secondary { color: var(--color-text-secondary); }
.text-muted { color: var(--color-text-muted); }

/* Display Utilities */
.block { display: block; }
.inline-block { display: inline-block; }
.inline { display: inline; }
.hidden { display: none; }

/* Position Utilities */
.relative { position: relative; }
.absolute { position: absolute; }
.fixed { position: fixed; }
.sticky { position: sticky; }

/* Visibility */
.visible { visibility: visible; }
.invisible { visibility: hidden; }

/* Overflow */
.overflow-hidden { overflow: hidden; }
.overflow-auto { overflow: auto; }
.overflow-scroll { overflow: scroll; }
.overflow-x-hidden { overflow-x: hidden; }
.overflow-y-hidden { overflow-y: hidden; }
.overflow-x-auto { overflow-x: auto; }
.overflow-y-auto { overflow-y: auto; }

/* Border Radius */
.rounded { border-radius: var(--radius-base); }
.rounded-md { border-radius: var(--radius-md); }
.rounded-lg { border-radius: var(--radius-lg); }
.rounded-xl { border-radius: var(--radius-xl); }
.rounded-full { border-radius: var(--radius-full); }

/* Shadows */
.shadow { box-shadow: var(--shadow-base); }
.shadow-sm { box-shadow: var(--shadow-sm); }
.shadow-md { box-shadow: var(--shadow-md); }
.shadow-lg { box-shadow: var(--shadow-lg); }
.shadow-xl { box-shadow: var(--shadow-xl); }
.shadow-none { box-shadow: none; }

/* Transitions */
.transition { transition: all var(--transition-base); }
.transition-fast { transition: all var(--transition-fast); }
.transition-slow { transition: all var(--transition-slow); }
.transition-none { transition: none; }

/* ==========================================================================
   Accessibility and Screen Reader Utilities
   ========================================================================== */

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.not-sr-only {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

/* Focus styles for better accessibility */
.focus-visible:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}

/* Skip links */
.skip-link {
  position: absolute;
  top: -40px;
  left: 6px;
  background: var(--color-primary);
  color: white;
  padding: 8px;
  text-decoration: none;
  border-radius: var(--radius-md);
  z-index: var(--z-max);
}

.skip-link:focus {
  top: 6px;
}

/* ==========================================================================
   State Utilities
   ========================================================================== */

/* Loading states */
.loading {
  opacity: 0.6;
  pointer-events: none;
  cursor: wait;
}

.spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* Error and success states */
.error {
  color: var(--color-error);
  border-color: var(--color-error);
}

.success {
  color: var(--color-success);
  border-color: var(--color-success);
}

.warning {
  color: var(--color-warning);
  border-color: var(--color-warning);
}

.info {
  color: var(--color-info);
  border-color: var(--color-info);
}

/* ==========================================================================
   Responsive Design
   ========================================================================== */

@media (min-width: 640px) {
  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .sm\\:flex-row { flex-direction: row; }
  .sm\\:text-left { text-align: left; }
  .sm\\:block { display: block; }
  .sm\\:hidden { display: none; }
}

@media (min-width: 768px) {
  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .md\\:flex-row { flex-direction: row; }
  .md\\:block { display: block; }
  .md\\:hidden { display: none; }
  .md\\:text-lg { font-size: var(--font-size-lg); }
  .md\\:text-xl { font-size: var(--font-size-xl); }
}

@media (min-width: 1024px) {
  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
  .lg\\:block { display: block; }
  .lg\\:hidden { display: none; }
  .lg\\:text-xl { font-size: var(--font-size-xl); }
  .lg\\:text-2xl { font-size: var(--font-size-2xl); }
}

/* ==========================================================================
   Print Styles
   ========================================================================== */

@media print {
  *,
  *::before,
  *::after {
    background: white !important;
    color: black !important;
    box-shadow: none !important;
  }
  
  a,
  a:visited {
    text-decoration: underline;
  }
  
  a[href]:after {
    content: " (" attr(href) ")";
  }
  
  abbr[title]:after {
    content: " (" attr(title) ")";
  }
  
  pre,
  blockquote {
    border: 1px solid #999;
    page-break-inside: avoid;
  }
  
  thead {
    display: table-header-group;
  }
  
  tr,
  img {
    page-break-inside: avoid;
  }
  
  img {
    max-width: 100% !important;
  }
  
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  
  h2,
  h3 {
    page-break-after: avoid;
  }
  
  .no-print {
    display: none !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/styles/globals.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAGzB,iCAAiC;;AAGjC;;+EAE+E;;AAE/E,qBAAqB;AACrB;;;EAGE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,SAAS;EACT,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,uCAAuC;EACvC,gCAAgC;EAChC,sCAAsC;EACtC,sCAAsC;EACtC,wBAAwB;EACxB,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA,2DAA2D;AAC3D;;EAEE,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,8BAA8B;AAChC;;AAEA,oCAAoC;AACpC;;;EAGE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;;;;EAIE,aAAa;AACf;;AAEA,wDAAwD;AACxD;EACE;GACC,qBAAqB;EACtB;;EAEA;;;IAGE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;IACtC,gCAAgC;EAClC;AACF;;AAEA;;+EAE+E;;AAE/E,aAAa;AACb;EACE,uCAAuC;EACvC,oCAAoC;EACpC,qCAAqC;EACrC,wBAAwB;EACxB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,wCAAwC;EACxC,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;EACvC,iBAAiB;EACjB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;;;;EAIE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,+BAA+B;EAC/B,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;EACE,sCAAsC;EACtC,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,2CAA2C;EAC3C,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;;+EAE+E;;AAE/E;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;;EAEE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,0CAA0C;EAC1C,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,8BAA8B;EAC9B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E,0CAA0C;AAC1C;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;;;EAGE,WAAW;EACX,0CAA0C;EAC1C,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,kCAAkC;EAClC,yDAAyD;AAC3D;;AAEA;;EAEE,8BAA8B;EAC9B,UAAU;AACZ;;AAEA,yBAAyB;AACzB;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,aAAa;AACb;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,yDAAmP;EACnP,kDAAkD;EAClD,4BAA4B;EAC5B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;;EAEE,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA,WAAW;AACX;EACE,cAAc;EACd,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;EACxB,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;EACf,YAAY;EACZ,+BAA+B;EAC/B,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,cAAc;EACd,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,4BAA4B;AAC9B;;AAEA;EACE,wCAAwC;EACxC,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;+EAE+E;;AAE/E,WAAW;AACX;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,8BAA8B;EAC9B,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;;EAEE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E;EACE,WAAW;EACX,8BAA8B;EAC9B,cAAc;EACd,2BAA2B;AAC7B;;AAEA,gBAAgB,8BAA8B,EAAE;AAChD,gBAAgB,8BAA8B,EAAE;AAChD,gBAAgB,8BAA8B,EAAE;AAChD,iBAAiB,+BAA+B,EAAE;;AAElD,sBAAsB;AACtB,QAAQ,aAAa,EAAE;AACvB,eAAe,oBAAoB,EAAE;AACrC,YAAY,sBAAsB,EAAE;AACpC,YAAY,mBAAmB,EAAE;AACjC,aAAa,eAAe,EAAE;AAC9B,eAAe,iBAAiB,EAAE;;AAElC,eAAe,uBAAuB,EAAE;AACxC,gBAAgB,mBAAmB,EAAE;AACrC,aAAa,qBAAqB,EAAE;AACpC,iBAAiB,oBAAoB,EAAE;AACvC,kBAAkB,qBAAqB,EAAE;;AAEzC,iBAAiB,2BAA2B,EAAE;AAC9C,kBAAkB,uBAAuB,EAAE;AAC3C,eAAe,yBAAyB,EAAE;AAC1C,mBAAmB,8BAA8B,EAAE;AACnD,kBAAkB,6BAA6B,EAAE;AACjD,kBAAkB,6BAA6B,EAAE;;AAEjD,UAAU,YAAY,EAAE;AACxB,aAAa,cAAc,EAAE;AAC7B,gBAAgB,cAAc,EAAE;AAChC,aAAa,UAAU,EAAE;;AAEzB,mBAAmB;AACnB,QAAQ,aAAa,EAAE;AACvB,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,eAAe,gDAAgD,EAAE;AACjE,gBAAgB,iDAAiD,EAAE;;AAEnE,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;AAChC,SAAS,qBAAqB,EAAE;;AAEhC,sBAAsB;AACtB,OAAO,SAAS,EAAE;AAClB,UAAU,YAAY,EAAE;AACxB,WAAW,iBAAiB,EAAE,kBAAkB,EAAE;AAClD,WAAW,gBAAgB,EAAE,mBAAmB,EAAE;;AAElD,OAAO,UAAU,EAAE;AACnB,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;AAClC,OAAO,yBAAyB,EAAE;;AAElC,QAAQ,8BAA8B,EAAE,+BAA+B,EAAE;AACzE,QAAQ,6BAA6B,EAAE,gCAAgC,EAAE;;AAEzE,mBAAmB;AACnB,aAAa,gBAAgB,EAAE;AAC/B,eAAe,kBAAkB,EAAE;AACnC,cAAc,iBAAiB,EAAE;AACjC,gBAAgB,mBAAmB,EAAE;;AAErC,WAAW,8BAA8B,EAAE;AAC3C,WAAW,8BAA8B,EAAE;AAC3C,aAAa,gCAAgC,EAAE;AAC/C,WAAW,8BAA8B,EAAE;AAC3C,WAAW,8BAA8B,EAAE;AAC3C,YAAY,+BAA+B,EAAE;AAC7C,YAAY,+BAA+B,EAAE;;AAE7C,cAAc,qCAAqC,EAAE;AACrD,eAAe,sCAAsC,EAAE;AACvD,eAAe,sCAAsC,EAAE;AACvD,iBAAiB,wCAAwC,EAAE;AAC3D,aAAa,oCAAoC,EAAE;;AAEnD,gBAAgB,2BAA2B,EAAE;AAC7C,kBAAkB,kCAAkC,EAAE;AACtD,cAAc,8BAA8B,EAAE;;AAE9C,sBAAsB;AACtB,SAAS,cAAc,EAAE;AACzB,gBAAgB,qBAAqB,EAAE;AACvC,UAAU,eAAe,EAAE;AAC3B,UAAU,aAAa,EAAE;;AAEzB,uBAAuB;AACvB,YAAY,kBAAkB,EAAE;AAChC,YAAY,kBAAkB,EAAE;AAChC,SAAS,eAAe,EAAE;AAC1B,UAAU,gBAAgB,EAAE;;AAE5B,eAAe;AACf,WAAW,mBAAmB,EAAE;AAChC,aAAa,kBAAkB,EAAE;;AAEjC,aAAa;AACb,mBAAmB,gBAAgB,EAAE;AACrC,iBAAiB,cAAc,EAAE;AACjC,mBAAmB,gBAAgB,EAAE;AACrC,qBAAqB,kBAAkB,EAAE;AACzC,qBAAqB,kBAAkB,EAAE;AACzC,mBAAmB,gBAAgB,EAAE;AACrC,mBAAmB,gBAAgB,EAAE;;AAErC,kBAAkB;AAClB,WAAW,iCAAiC,EAAE;AAC9C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,cAAc,+BAA+B,EAAE;AAC/C,gBAAgB,iCAAiC,EAAE;;AAEnD,YAAY;AACZ,UAAU,8BAA8B,EAAE;AAC1C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,aAAa,4BAA4B,EAAE;AAC3C,eAAe,gBAAgB,EAAE;;AAEjC,gBAAgB;AAChB,cAAc,sCAAsC,EAAE;AACtD,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,sCAAsC,EAAE;AAC3D,mBAAmB,gBAAgB,EAAE;;AAErC;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,QAAQ;AACV;;AAEA;;+EAE+E;;AAE/E,mBAAmB;AACnB;EACE,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;;+EAE+E;;AAE/E;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,iBAAiB,gBAAgB,EAAE;EACnC,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;AAC/B;;AAEA;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,gBAAgB,mBAAmB,EAAE;EACrC,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,eAAe,8BAA8B,EAAE;EAC/C,eAAe,8BAA8B,EAAE;AACjD;;AAEA;EACE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,mBAAmB,gDAAgD,EAAE;EACrE,aAAa,cAAc,EAAE;EAC7B,cAAc,aAAa,EAAE;EAC7B,eAAe,8BAA8B,EAAE;EAC/C,gBAAgB,+BAA+B,EAAE;AACnD;;AAEA;;+EAE+E;;AAE/E;EACE;;;IAGE,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Import CSS Variables */\n@import './variables.css';\n\n/* Import Advanced CSS Features */\n@import './advanced.css';\n\n/* ==========================================================================\n   CSS Reset and Normalize\n   ========================================================================== */\n\n/* Modern CSS Reset */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n/* Remove default margins and paddings */\n* {\n  margin: 0;\n  padding: 0;\n}\n\n/* HTML and Body */\nhtml {\n  font-size: 16px;\n  scroll-behavior: smooth;\n  -webkit-text-size-adjust: 100%;\n  -ms-text-size-adjust: 100%;\n  -moz-text-size-adjust: 100%;\n  text-size-adjust: 100%;\n  line-height: 1.15;\n  -webkit-tap-highlight-color: transparent;\n}\n\nbody {\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-base);\n  font-weight: var(--font-weight-normal);\n  line-height: var(--line-height-normal);\n  color: var(--color-text);\n  background-color: var(--color-background);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  font-feature-settings: \"kern\" 1;\n  font-kerning: normal;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* Screen Reader Only Content */\n.sr-only {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important;\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n.sr-only:focus {\n  position: static !important;\n  width: auto !important;\n  height: auto !important;\n  padding: inherit !important;\n  margin: inherit !important;\n  overflow: visible !important;\n  clip: auto !important;\n  white-space: inherit !important;\n}\n\n/* Remove list styles on ul, ol elements with a list role */\nul[role='list'],\nol[role='list'] {\n  list-style: none;\n}\n\n/* Set core root defaults */\nhtml:focus-within {\n  scroll-behavior: smooth;\n}\n\n/* Set core body defaults */\nbody {\n  text-rendering: optimizeSpeed;\n  line-height: 1.5;\n}\n\n/* A elements that don't have a class get default styles */\na:not([class]) {\n  text-decoration-skip-ink: auto;\n}\n\n/* Make images easier to work with */\nimg,\npicture,\nsvg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Remove built-in form typography styles */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* Remove animations for people who've turned them off */\n@media (prefers-reduced-motion: reduce) {\n  html:focus-within {\n   scroll-behavior: auto;\n  }\n  \n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n\n/* ==========================================================================\n   Typography System\n   ========================================================================== */\n\n/* Headings */\nh1, h2, h3, h4, h5, h6 {\n  font-family: var(--font-family-heading);\n  font-weight: var(--font-weight-bold);\n  line-height: var(--line-height-tight);\n  color: var(--color-text);\n  margin-bottom: var(--spacing-4);\n  text-wrap: balance;\n}\n\nh1 {\n  font-size: var(--font-size-5xl);\n  font-weight: var(--font-weight-extrabold);\n  line-height: var(--line-height-tight);\n  letter-spacing: var(--letter-spacing-tight);\n}\n\nh2 {\n  font-size: var(--font-size-4xl);\n  font-weight: var(--font-weight-bold);\n  line-height: var(--line-height-tight);\n  letter-spacing: var(--letter-spacing-tight);\n}\n\nh3 {\n  font-size: var(--font-size-3xl);\n  font-weight: var(--font-weight-bold);\n  line-height: var(--line-height-snug);\n}\n\nh4 {\n  font-size: var(--font-size-2xl);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-snug);\n}\n\nh5 {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  line-height: var(--line-height-normal);\n}\n\nh6 {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-medium);\n  line-height: var(--line-height-normal);\n}\n\n/* Paragraphs and Text */\np {\n  margin-bottom: var(--spacing-4);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-relaxed);\n  text-wrap: pretty;\n  orphans: 2;\n  widows: 2;\n}\n\np:last-child {\n  margin-bottom: 0;\n}\n\n/* Strong and emphasis */\nstrong,\nb {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-text);\n}\n\nem,\ni {\n  font-style: italic;\n}\n\n/* Small text */\nsmall {\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n}\n\n/* Code and preformatted text */\ncode,\nkbd,\nsamp,\npre {\n  font-family: var(--font-family-mono);\n  font-size: 0.9em;\n}\n\ncode {\n  background-color: var(--color-surface);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-sm);\n  color: var(--color-text);\n  border: 1px solid var(--color-border);\n}\n\npre {\n  background-color: var(--color-surface);\n  padding: var(--spacing-4);\n  border-radius: var(--radius-md);\n  overflow-x: auto;\n  border: 1px solid var(--color-border);\n  line-height: var(--line-height-relaxed);\n}\n\npre code {\n  background: none;\n  padding: 0;\n  border: none;\n  border-radius: 0;\n}\n\n/* Blockquotes */\nblockquote {\n  margin: var(--spacing-6) 0;\n  padding: var(--spacing-4) var(--spacing-6);\n  border-left: 4px solid var(--color-primary);\n  background-color: var(--color-surface);\n  border-radius: var(--radius-md);\n  font-style: italic;\n  color: var(--color-text-secondary);\n}\n\nblockquote p {\n  margin-bottom: var(--spacing-2);\n}\n\nblockquote p:last-child {\n  margin-bottom: 0;\n}\n\nblockquote cite {\n  display: block;\n  margin-top: var(--spacing-2);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n  font-style: normal;\n}\n\nblockquote cite::before {\n  content: \"— \";\n}\n\n/* ==========================================================================\n   Links and Navigation\n   ========================================================================== */\n\na {\n  color: var(--color-primary);\n  text-decoration: none;\n  transition: color var(--transition-fast);\n  cursor: pointer;\n}\n\na:hover {\n  color: var(--color-primary-light);\n  text-decoration: underline;\n}\n\na:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm);\n}\n\na:focus:not(:focus-visible) {\n  outline: none;\n}\n\na:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n  border-radius: var(--radius-sm);\n}\n\n/* External links */\na[href^=\"http\"]:not([href*=\"s-cubus.com\"]):not(.btn)::after {\n  content: \" ↗\";\n  font-size: 0.8em;\n  opacity: 0.7;\n}\n\na.btn:hover {\n  text-decoration: none;\n}\n\n/* ==========================================================================\n   Lists\n   ========================================================================== */\n\nul, ol {\n  margin-bottom: var(--spacing-4);\n  padding-left: var(--spacing-6);\n}\n\nul {\n  list-style-type: disc;\n}\n\nol {\n  list-style-type: decimal;\n}\n\nli {\n  margin-bottom: var(--spacing-2);\n  color: var(--color-text-secondary);\n  line-height: var(--line-height-relaxed);\n}\n\nli:last-child {\n  margin-bottom: 0;\n}\n\n/* Nested lists */\nli ul,\nli ol {\n  margin-top: var(--spacing-2);\n  margin-bottom: var(--spacing-2);\n}\n\n/* Description lists */\ndl {\n  margin-bottom: var(--spacing-4);\n}\n\ndt {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text);\n  margin-bottom: var(--spacing-1);\n}\n\ndd {\n  margin-bottom: var(--spacing-3);\n  margin-left: var(--spacing-4);\n  color: var(--color-text-secondary);\n}\n\n/* ==========================================================================\n   Tables\n   ========================================================================== */\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: var(--spacing-6);\n  background-color: var(--color-surface);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\nthead {\n  background-color: var(--color-surface-elevated);\n}\n\nth,\ntd {\n  padding: var(--spacing-3) var(--spacing-4);\n  text-align: left;\n  border-bottom: 1px solid var(--color-border);\n}\n\nth {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text);\n  font-size: var(--font-size-sm);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wide);\n}\n\ntd {\n  color: var(--color-text-secondary);\n}\n\ntbody tr:hover {\n  background-color: var(--color-surface);\n}\n\ntbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ==========================================================================\n   Forms and Inputs\n   ========================================================================== */\n\n/* Form elements inherit font properties */\ninput,\ntextarea,\nselect,\nbutton {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: inherit;\n}\n\n/* Form controls */\ninput,\ntextarea,\nselect {\n  width: 100%;\n  padding: var(--spacing-3) var(--spacing-4);\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  background-color: var(--color-surface);\n  color: var(--color-text);\n  transition: all var(--transition-fast);\n  appearance: none;\n}\n\ninput:focus,\ntextarea:focus,\nselect:focus {\n  outline: none;\n  border-color: var(--color-primary);\n  box-shadow: 0 0 0 3px rgba(var(--color-primary-rgb), 0.1);\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: var(--color-text-muted);\n  opacity: 1;\n}\n\n/* Specific input types */\ninput[type=\"search\"] {\n  -webkit-appearance: textfield;\n}\n\ninput[type=\"search\"]::-webkit-search-decoration,\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: none;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Textarea */\ntextarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n/* Select */\nselect {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e\");\n  background-position: right var(--spacing-3) center;\n  background-repeat: no-repeat;\n  background-size: 16px 12px;\n  padding-right: var(--spacing-10);\n}\n\n/* Checkboxes and radio buttons */\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  width: auto;\n  margin-right: var(--spacing-2);\n  accent-color: var(--color-primary);\n}\n\n/* Labels */\nlabel {\n  display: block;\n  margin-bottom: var(--spacing-2);\n  font-weight: var(--font-weight-medium);\n  color: var(--color-text);\n  cursor: pointer;\n}\n\n/* Fieldsets */\nfieldset {\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius-md);\n  padding: var(--spacing-4);\n  margin-bottom: var(--spacing-4);\n}\n\nlegend {\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-text);\n  padding: 0 var(--spacing-2);\n}\n\n/* ==========================================================================\n   Buttons\n   ========================================================================== */\n\nbutton {\n  cursor: pointer;\n  border: none;\n  border-radius: var(--radius-md);\n  padding: var(--spacing-3) var(--spacing-6);\n  font-weight: var(--font-weight-medium);\n  text-align: center;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: var(--spacing-2);\n  transition: all var(--transition-fast);\n  position: relative;\n  overflow: hidden;\n  white-space: nowrap;\n  user-select: none;\n  -webkit-user-select: none;\n  touch-action: manipulation;\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\nbutton:focus {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\nbutton:focus:not(:focus-visible) {\n  outline: none;\n}\n\nbutton:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n/* Button Variants */\n.btn-primary {\n  background-color: var(--color-primary);\n  color: white;\n  border: 2px solid var(--color-primary);\n}\n\n.btn-primary:hover:not(:disabled) {\n  background-color: var(--color-primary-light);\n  border-color: var(--color-primary-light);\n  color: #f59e0b;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-primary:active {\n  transform: translateY(0);\n  box-shadow: var(--shadow-sm);\n}\n\n.btn-secondary {\n  background-color: var(--color-secondary);\n  color: white;\n  border: 2px solid var(--color-secondary);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background-color: var(--color-secondary-light);\n  border-color: var(--color-secondary-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-outline {\n  background-color: transparent;\n  color: var(--color-primary);\n  border: 2px solid var(--color-primary);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background-color: var(--color-primary);\n  color: white;\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-ghost {\n  background-color: transparent;\n  color: var(--color-text);\n  border: 2px solid transparent;\n}\n\n.btn-ghost:hover:not(:disabled) {\n  background-color: var(--color-surface);\n  border-color: var(--color-border);\n}\n\n.btn-success {\n  background-color: var(--color-success);\n  color: white;\n  border: 2px solid var(--color-success);\n}\n\n.btn-success:hover:not(:disabled) {\n  background-color: var(--color-success-light);\n  border-color: var(--color-success-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-warning {\n  background-color: var(--color-warning);\n  color: white;\n  border: 2px solid var(--color-warning);\n}\n\n.btn-warning:hover:not(:disabled) {\n  background-color: var(--color-warning-light);\n  border-color: var(--color-warning-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.btn-error {\n  background-color: var(--color-error);\n  color: white;\n  border: 2px solid var(--color-error);\n}\n\n.btn-error:hover:not(:disabled) {\n  background-color: var(--color-error-light);\n  border-color: var(--color-error-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* ==========================================================================\n   Media Elements\n   ========================================================================== */\n\n/* Images */\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  border-radius: var(--radius-md);\n}\n\n/* Figures */\nfigure {\n  margin: var(--spacing-6) 0;\n}\n\nfigcaption {\n  margin-top: var(--spacing-2);\n  font-size: var(--font-size-sm);\n  color: var(--color-text-muted);\n  text-align: center;\n  font-style: italic;\n}\n\n/* Audio and Video */\naudio,\nvideo {\n  width: 100%;\n  height: auto;\n  border-radius: var(--radius-md);\n}\n\n/* ==========================================================================\n   Utility Classes - Layout\n   ========================================================================== */\n\n.container {\n  width: 100%;\n  max-width: var(--container-xl);\n  margin: 0 auto;\n  padding: 0 var(--spacing-4);\n}\n\n.container-sm { max-width: var(--container-sm); }\n.container-md { max-width: var(--container-md); }\n.container-lg { max-width: var(--container-lg); }\n.container-2xl { max-width: var(--container-2xl); }\n\n/* Flexbox Utilities */\n.flex { display: flex; }\n.inline-flex { display: inline-flex; }\n.flex-col { flex-direction: column; }\n.flex-row { flex-direction: row; }\n.flex-wrap { flex-wrap: wrap; }\n.flex-nowrap { flex-wrap: nowrap; }\n\n.items-start { align-items: flex-start; }\n.items-center { align-items: center; }\n.items-end { align-items: flex-end; }\n.items-stretch { align-items: stretch; }\n.items-baseline { align-items: baseline; }\n\n.justify-start { justify-content: flex-start; }\n.justify-center { justify-content: center; }\n.justify-end { justify-content: flex-end; }\n.justify-between { justify-content: space-between; }\n.justify-around { justify-content: space-around; }\n.justify-evenly { justify-content: space-evenly; }\n\n.flex-1 { flex: 1 1 0%; }\n.flex-auto { flex: 1 1 auto; }\n.flex-initial { flex: 0 1 auto; }\n.flex-none { flex: none; }\n\n/* Grid Utilities */\n.grid { display: grid; }\n.grid-cols-1 { grid-template-columns: repeat(1, minmax(0, 1fr)); }\n.grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n.grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n.grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n.grid-cols-5 { grid-template-columns: repeat(5, minmax(0, 1fr)); }\n.grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n.grid-cols-12 { grid-template-columns: repeat(12, minmax(0, 1fr)); }\n\n.gap-1 { gap: var(--spacing-1); }\n.gap-2 { gap: var(--spacing-2); }\n.gap-3 { gap: var(--spacing-3); }\n.gap-4 { gap: var(--spacing-4); }\n.gap-6 { gap: var(--spacing-6); }\n.gap-8 { gap: var(--spacing-8); }\n\n/* Spacing Utilities */\n.m-0 { margin: 0; }\n.m-auto { margin: auto; }\n.mx-auto { margin-left: auto; margin-right: auto; }\n.my-auto { margin-top: auto; margin-bottom: auto; }\n\n.p-0 { padding: 0; }\n.p-4 { padding: var(--spacing-4); }\n.p-6 { padding: var(--spacing-6); }\n.p-8 { padding: var(--spacing-8); }\n\n.px-4 { padding-left: var(--spacing-4); padding-right: var(--spacing-4); }\n.py-4 { padding-top: var(--spacing-4); padding-bottom: var(--spacing-4); }\n\n/* Text Utilities */\n.text-left { text-align: left; }\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.text-justify { text-align: justify; }\n\n.text-xs { font-size: var(--font-size-xs); }\n.text-sm { font-size: var(--font-size-sm); }\n.text-base { font-size: var(--font-size-base); }\n.text-lg { font-size: var(--font-size-lg); }\n.text-xl { font-size: var(--font-size-xl); }\n.text-2xl { font-size: var(--font-size-2xl); }\n.text-3xl { font-size: var(--font-size-3xl); }\n\n.font-light { font-weight: var(--font-weight-light); }\n.font-normal { font-weight: var(--font-weight-normal); }\n.font-medium { font-weight: var(--font-weight-medium); }\n.font-semibold { font-weight: var(--font-weight-semibold); }\n.font-bold { font-weight: var(--font-weight-bold); }\n\n.text-primary { color: var(--color-primary); }\n.text-secondary { color: var(--color-text-secondary); }\n.text-muted { color: var(--color-text-muted); }\n\n/* Display Utilities */\n.block { display: block; }\n.inline-block { display: inline-block; }\n.inline { display: inline; }\n.hidden { display: none; }\n\n/* Position Utilities */\n.relative { position: relative; }\n.absolute { position: absolute; }\n.fixed { position: fixed; }\n.sticky { position: sticky; }\n\n/* Visibility */\n.visible { visibility: visible; }\n.invisible { visibility: hidden; }\n\n/* Overflow */\n.overflow-hidden { overflow: hidden; }\n.overflow-auto { overflow: auto; }\n.overflow-scroll { overflow: scroll; }\n.overflow-x-hidden { overflow-x: hidden; }\n.overflow-y-hidden { overflow-y: hidden; }\n.overflow-x-auto { overflow-x: auto; }\n.overflow-y-auto { overflow-y: auto; }\n\n/* Border Radius */\n.rounded { border-radius: var(--radius-base); }\n.rounded-md { border-radius: var(--radius-md); }\n.rounded-lg { border-radius: var(--radius-lg); }\n.rounded-xl { border-radius: var(--radius-xl); }\n.rounded-full { border-radius: var(--radius-full); }\n\n/* Shadows */\n.shadow { box-shadow: var(--shadow-base); }\n.shadow-sm { box-shadow: var(--shadow-sm); }\n.shadow-md { box-shadow: var(--shadow-md); }\n.shadow-lg { box-shadow: var(--shadow-lg); }\n.shadow-xl { box-shadow: var(--shadow-xl); }\n.shadow-none { box-shadow: none; }\n\n/* Transitions */\n.transition { transition: all var(--transition-base); }\n.transition-fast { transition: all var(--transition-fast); }\n.transition-slow { transition: all var(--transition-slow); }\n.transition-none { transition: none; }\n\n/* ==========================================================================\n   Accessibility and Screen Reader Utilities\n   ========================================================================== */\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.not-sr-only {\n  position: static;\n  width: auto;\n  height: auto;\n  padding: 0;\n  margin: 0;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n/* Focus styles for better accessibility */\n.focus-visible:focus-visible {\n  outline: 2px solid var(--color-primary);\n  outline-offset: 2px;\n}\n\n/* Skip links */\n.skip-link {\n  position: absolute;\n  top: -40px;\n  left: 6px;\n  background: var(--color-primary);\n  color: white;\n  padding: 8px;\n  text-decoration: none;\n  border-radius: var(--radius-md);\n  z-index: var(--z-max);\n}\n\n.skip-link:focus {\n  top: 6px;\n}\n\n/* ==========================================================================\n   State Utilities\n   ========================================================================== */\n\n/* Loading states */\n.loading {\n  opacity: 0.6;\n  pointer-events: none;\n  cursor: wait;\n}\n\n.spinner {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border: 2px solid transparent;\n  border-top: 2px solid currentColor;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error and success states */\n.error {\n  color: var(--color-error);\n  border-color: var(--color-error);\n}\n\n.success {\n  color: var(--color-success);\n  border-color: var(--color-success);\n}\n\n.warning {\n  color: var(--color-warning);\n  border-color: var(--color-warning);\n}\n\n.info {\n  color: var(--color-info);\n  border-color: var(--color-info);\n}\n\n/* ==========================================================================\n   Responsive Design\n   ========================================================================== */\n\n@media (min-width: 640px) {\n  .sm\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .sm\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .sm\\:flex-row { flex-direction: row; }\n  .sm\\:text-left { text-align: left; }\n  .sm\\:block { display: block; }\n  .sm\\:hidden { display: none; }\n}\n\n@media (min-width: 768px) {\n  .md\\:grid-cols-2 { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .md\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .md\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .md\\:flex-row { flex-direction: row; }\n  .md\\:block { display: block; }\n  .md\\:hidden { display: none; }\n  .md\\:text-lg { font-size: var(--font-size-lg); }\n  .md\\:text-xl { font-size: var(--font-size-xl); }\n}\n\n@media (min-width: 1024px) {\n  .lg\\:grid-cols-3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .lg\\:grid-cols-4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }\n  .lg\\:grid-cols-6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }\n  .lg\\:block { display: block; }\n  .lg\\:hidden { display: none; }\n  .lg\\:text-xl { font-size: var(--font-size-xl); }\n  .lg\\:text-2xl { font-size: var(--font-size-2xl); }\n}\n\n/* ==========================================================================\n   Print Styles\n   ========================================================================== */\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    background: white !important;\n    color: black !important;\n    box-shadow: none !important;\n  }\n  \n  a,\n  a:visited {\n    text-decoration: underline;\n  }\n  \n  a[href]:after {\n    content: \" (\" attr(href) \")\";\n  }\n  \n  abbr[title]:after {\n    content: \" (\" attr(title) \")\";\n  }\n  \n  pre,\n  blockquote {\n    border: 1px solid #999;\n    page-break-inside: avoid;\n  }\n  \n  thead {\n    display: table-header-group;\n  }\n  \n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  \n  img {\n    max-width: 100% !important;\n  }\n  \n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  \n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  \n  .no-print {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
